module.exports = __webpack_public_path__ + "static/media/icon6.92fc082f.png";